const navItems = Object.freeze({
  HOME: 'home',
  ALERT: 'alert',
  ALERTSV2: 'alertsV2',
  NOTIFICATION: 'notification',
  APM: 'apm',
  BROWSER: 'browser',
  SETTINGS: 'settings',
  VM: 'vm',
  MOBILE: 'mobile',
  DATABASE: 'database',
  WSM: 'wsm',
  SM: 'sm',
  K8M: 'k8m',
  INTEGRATIONS: 'integrations',
  CLOUD: 'cloud',
  LOG: 'log',
  ANALYTICS: 'analytics',
  DE: 'digitalExperience',
  BILLING: 'usages',
  MQ: 'mq',
});

export { navItems };
